import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useTranslation from '../../../Hooks/useTranslation';
import peticion from '../../../Api/employeesPage';

const useEmployee = setIsLoading => {
  const { t } = useTranslation();
  const history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [terminal, setTerminal] = useState([]);
  const [department, setDepartment] = useState([]);
  const [role, setRole] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      peticion(t).then(data => {
        setEmployees(data.employees);
        setTerminal(data.terminal);
        setDepartment(data.department);
        setRole(data.role);
        setIsLoading(false);
      });
    }

    return () => {
      isMounted = false;
      setEmployees([]);
      setTerminal([]);
      setDepartment([]);
      setRole([]);
    };
  }, []);

  const sendToEmployeesAssess = user => {
    history.push({
      pathname: '/empleado/desarrollo',
      state: {
        update: true,
        user,
        isComingFrom: '/empleado',
      },
    });
  };

  return {
    employees,
    setEmployees,
    terminal,
    department,
    role,
    sendToEmployeesAssess,
  };
};

export default useEmployee;
